import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ConstructionIcon from '@mui/icons-material/Construction';

interface ComingSoonProps {
  featureName: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ featureName }) => {
  const { t } = useTranslation('admin');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <Paper
        elevation={2}
        sx={{
          p: 4,
          textAlign: 'center',
          maxWidth: 500,
        }}
      >
        <ConstructionIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          {t('comingSoon.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('comingSoon.message', { feature: featureName })}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ComingSoon;
